import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import hasPermi from './modules/hasPermi'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    menu,
    hasPermi
  }
})
export default store
